import { TOGGLE_SIDEBAR } from '../actions';
export const defaultState = {
    isOpen: true
};
export const sidebarReducer = (state = defaultState, action) => {
    switch (action.type) {
        case TOGGLE_SIDEBAR: {
            return Object.assign(Object.assign({}, state), { isOpen: action.payload });
        }
        default: {
            return state;
        }
    }
};
